import { useAppScopeStore } from '@frontend/scope';
import { useAppFlagStore } from '@frontend/shared';

export const useGetUnifiedThreadEnabled = (locationIds?: string[]) => {
  const { selectedLocationIds } = useAppScopeStore();
  const { getFeatureFlagValue } = useAppFlagStore();
  const unifiedThreadEnabled = getFeatureFlagValue({
    flagName: 'nwx:unified-thread',
    locationIds: locationIds || selectedLocationIds,
    strategy: 'ANY',
  });
  return unifiedThreadEnabled;
};
